var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-imovel-denominacao", {
        attrs: {
          required: true,
          imovel: _vm.cadastro.imovel,
          tipoCadastro: "AFORAMENTO"
        }
      }),
      _c("app-matricula-imovel", {
        attrs: { imovel: _vm.cadastro.imovel, required: true }
      }),
      _c("app-divider", { attrs: { label: "Dados do Título" } }),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Nome do beneficiário:", required: false }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "Nome do beneficiário", maxlength: "300" },
                model: {
                  value: _vm.cadastro.imovel.nomeBeneficiarioTitulo,
                  callback: function($$v) {
                    _vm.$set(_vm.cadastro.imovel, "nomeBeneficiarioTitulo", $$v)
                  },
                  expression: "cadastro.imovel.nomeBeneficiarioTitulo"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("app-documentos", {
        attrs: {
          maxSize: 25000,
          "valid-extensions": ["pdf", "rar", "zip"],
          documentos: _vm.cadastro.imovel.documentos,
          tiposDocumentos: _vm.documentos,
          tiposDocumentosObrigatorios: _vm.documentosObrigatorios,
          observer: _vm.observer,
          aba: "Imóvel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c7de2c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c7de2c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/resgateAforamento/components/Imovel.vue
// module id = null
// module chunks = 